(function () {
  "use strict";


  const CART_SVG = `<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 001.99 1.61h9.72a2 2 0 001.99-1.72l1.38-9.28H6"/></svg>`;
  const CHECK_SVG = `<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>`;

  /* WH-172: bounded/retrying fetch with plain-fetch fallback; cart POSTs are
     duplicate-safe via cartMutate. */
  const ehFetch = (url, opts) =>
    window.EH && window.EH.fetchRetry ? window.EH.fetchRetry(url, opts) : fetch(url, opts);
  const ehCartPost = (url, payload) =>
    window.EH && window.EH.cartMutate
      ? window.EH.cartMutate(url, payload)
      : fetch(url, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });

  class SupportHeroBenefits {
    constructor(el) {
      this.el = el;
      this.scroll = el.querySelector("[data-shb-scroll]");

      if (this.scroll) {
        this._attachProgress(this.scroll);
        this._dragScroll(this.scroll);
      }

      this.el.addEventListener("click", (e) => {
        const btn = e.target.closest(".shb-card__add");
        if (btn) this._addToCart(btn);
      });
    }

    _attachProgress(scroll) {
      const next = scroll.nextElementSibling;
      const wrapper =
        next && next.classList.contains("shb-progress")
          ? next
          : (() => {
              const el = document.createElement("div");
              el.className = "shb-progress";
              el.innerHTML =
                '<div class="shb-progress__bar"><div class="shb-progress__thumb"></div></div>';
              scroll.after(el);
              return el;
            })();

      const thumb = wrapper.querySelector(".shb-progress__thumb");
      const bar = wrapper.querySelector(".shb-progress__bar");

      const update = () => {
        const maxScroll = scroll.scrollWidth - scroll.clientWidth;
        if (maxScroll <= 0) {
          wrapper.style.display = "none";
          return;
        }
        wrapper.style.display = "";
        const barW = bar.offsetWidth;
        const ratio = scroll.clientWidth / scroll.scrollWidth;
        const thumbW = Math.max(20, Math.round(barW * ratio));
        const thumbL = Math.round(
          (barW - thumbW) * (scroll.scrollLeft / maxScroll),
        );
        thumb.style.width = thumbW + "px";
        thumb.style.left = thumbL + "px";
      };

      scroll.addEventListener("scroll", update, { passive: true });
      const ro = new ResizeObserver(update);
      ro.observe(scroll);
      update();
      window.addEventListener("load", update, { once: true });
    }

    _getDrawerSectionId() {
      const el = document.querySelector("cart-drawer");
      if (!el) return null;
      const section = el.closest(".shopify-section");
      return section ? section.id.replace("shopify-section-", "") : null;
    }

    async _addToCart(btn) {
      const variantId = parseInt(btn.dataset.variantId, 10);
      if (!variantId) return;
      btn.disabled = true;
      btn.innerHTML = CHECK_SVG;
      try {
        const sectionId = this._getDrawerSectionId();
        const body = { items: [{ id: variantId, quantity: 1 }] };
        if (sectionId) body.sections = sectionId;

        const addRes = await ehCartPost("/cart/add.js", body);
        const addResp = await addRes.json();
        await this._refreshCart(addResp.sections);
        /* ── Analytics ── */
        var card = btn.closest('.shb-card');
        var title = card ? ((card.querySelector('.shb-card__title') || {}).textContent || '').trim() : '';
        var priceEl = card ? card.querySelector('.shb-card__price') : null;
        var priceVal = priceEl ? parseFloat(priceEl.textContent.replace(/[^\d.]/g, '')) || 0 : 0;
        if (window.fireAddToCartEvent) window.fireAddToCartEvent(String(variantId), title, priceVal);
      } catch (_) {}
      setTimeout(() => {
        btn.innerHTML = CART_SVG;
        btn.disabled = false;
      }, 1500);
    }

    async _refreshCart(addedSections) {
      try {
        const res = await ehFetch("/cart.js");
        const cart = await res.json();
        if (addedSections) cart.sections = addedSections;
        document.querySelectorAll("[data-cart-count]").forEach((el) => {
          el.textContent = cart.item_count;
        });
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:change", {
            bubbles: true,
            detail: { baseEvent: "variant:add", cart },
          }),
        );
      } catch (_) {}
    }

    _dragScroll(el) {
      let active = false,
        startX,
        startLeft;
      el.addEventListener("mousedown", (e) => {
        active = true;
        startX = e.pageX - el.offsetLeft;
        startLeft = el.scrollLeft;
        el.classList.add("is-dragging");
      });
      document.addEventListener("mouseup", () => {
        if (!active) return;
        active = false;
        el.classList.remove("is-dragging");
      });
      el.addEventListener("mousemove", (e) => {
        if (!active) return;
        e.preventDefault();
        el.scrollLeft = startLeft - (e.pageX - el.offsetLeft - startX) * 1.5;
      });
      el.addEventListener("mouseleave", () => {
        active = false;
        el.classList.remove("is-dragging");
      });
    }
  }

  function init() {
    document
      .querySelectorAll("[data-shb-section]")
      .forEach((el) => new SupportHeroBenefits(el));
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
